/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { FC } from 'react';
import { styled } from 'linaria/react';
import { FocusError, SteamFields, TspFields } from '@features/payment/payment-form';
import { ServerOption } from '@entities/server';
import { GetPriceResp } from '@entities/voucher';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import { Payee } from '@root/api/ump-catalog-manager';
interface Props {
  priceData?: GetPriceResp;
  getCommissions: (baseAmount: number) => void;
  showVouchersForm: boolean;
  activeService: Payee;
  servers: ServerOption[];
}
const AccountInfo: FC<Props> = ({
  priceData,
  getCommissions,
  showVouchersForm,
  activeService,
  servers
}) => <WrapperContent>
    <FormTitle>{showVouchersForm ? 'Оформление покупки' : 'Пополнение аккаунта'}</FormTitle>
    <Spacer space={16} spacetablet={16} spacemob={16} />
    <FormContainer className="ym-hide-content">
      {!showVouchersForm ? <SteamFields getCommissions={getCommissions} /> : <TspFields
    // @ts-ignore
    priceData={priceData} activeService={activeService} servers={servers} getCommissions={getCommissions} />}
    </FormContainer>
    <FocusError />
  </WrapperContent>;
export default AccountInfo;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.bg.secondary;
const WrapperContent = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperContent",
  class: "wrcmmox",
  propsAsIs: false,
  vars: {
    "wrcmmox-0": [_exp()]
  }
}));
const FormContainer = /*#__PURE__*/styled('div')({
  name: "FormContainer",
  class: "fwqlrvd",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.sm;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const FormTitle = withTheme(/*#__PURE__*/styled('div')({
  name: "FormTitle",
  class: "frcjmci",
  propsAsIs: false,
  vars: {
    "frcjmci-0": [_exp2()],
    "frcjmci-1": [_exp3(), "px"],
    "frcjmci-2": [_exp4()],
    "frcjmci-3": [_exp5(), "px"],
    "frcjmci-4": [_exp6()],
    "frcjmci-5": [_exp7(), "px"]
  }
}));

require("./AccountInfo.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./AccountInfo.tsx");